import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function QuickActionsGrid({ actions = [] }) {
  const navigate = useNavigate();

  const colorStyles = {
    amber: {
      bg: 'bg-amber-500/10 text-amber-700',
      border: 'border-amber-500/20 hover:border-amber-500/40',
      hover: 'hover:bg-amber-500/5',
    },
    emerald: {
      bg: 'bg-emerald-500/10 text-emerald-700',
      border: 'border-emerald-500/20 hover:border-emerald-500/40',
      hover: 'hover:bg-emerald-500/5',
    },
    blue: {
      bg: 'bg-blue-500/10 text-blue-700',
      border: 'border-blue-500/20 hover:border-blue-500/40',
      hover: 'hover:bg-blue-500/5',
    },
    indigo: {
      bg: 'bg-indigo-500/10 text-indigo-700',
      border: 'border-indigo-500/20 hover:border-indigo-500/40',
      hover: 'hover:bg-indigo-500/5',
    },
    sky: {
      bg: 'bg-sky-500/10 text-sky-700',
      border: 'border-sky-500/20 hover:border-sky-500/40',
      hover: 'hover:bg-sky-500/5',
    },
    purple: {
      bg: 'bg-purple-500/10 text-purple-700',
      border: 'border-purple-500/20 hover:border-purple-500/40',
      hover: 'hover:bg-purple-500/5',
    },
  };

  return (
    <div className="space-y-3">
      <div>
        <h3 className="text-sm font-extrabold uppercase tracking-wider text-black">
          Quick ESS Actions
        </h3>
        <p className="text-[11px] text-slate-500 font-medium">
          Fast-track self-service requests and inquiries
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {actions.map((act) => {
          const style = colorStyles[act.color] || colorStyles.blue;
          return (
            <div
              key={act.id}
              onClick={() => navigate(act.path)}
              className={`group flex flex-col justify-between rounded-2xl border ${style.border} bg-surface p-4 shadow-xs transition hover:shadow-sm hover:scale-[1.02] cursor-pointer ${style.hover}`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${style.bg} transition group-hover:scale-110`}>
                  <span className="material-symbols-outlined text-2xl">{act.icon}</span>
                </div>
                <span className="material-symbols-outlined text-slate-300 text-sm group-hover:text-primary transition group-hover:translate-x-0.5">
                  arrow_forward
                </span>
              </div>

              <div>
                <h4 className="text-xs font-bold text-on-surface">{act.label}</h4>
                <p className="mt-1 text-[11px] text-slate-500 line-clamp-2 leading-relaxed">
                  {act.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
